import React, { useContext, useEffect, useState } from 'react';
import axios from "axios";
import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
} from '@material-ui/core';
import { useStyles } from '../styles';
import Logo from '../components/Logo';
import {
  Button, CircularProgress, Dialog,
  DialogTitle,
} from '@material-ui/core';
import { setPaymentType, setOrderType, setCustomerId, updateCustomer } from '../actions';
import { Store } from '../Store';
import config, { getParameterByName, merchantCode } from '../util';
import { ORDER_SET_SCHEDULE_DATE } from '../constants';
import SignUp from './SignUp';

export default function HomeScreen(props) {
  const { state, dispatch } = useContext(Store);
  let customerInfo = sessionStorage.getItem("customerInfo");
  if (customerInfo) {
    customerInfo = JSON.parse(customerInfo);
  }
  const styles = useStyles();
  const { selectedCurrency, order, qr } = state;

  const [userName, setUserName] = useState(customerInfo?.customer?.firstName || "");
  const [userLName, setUserLName] = useState(customerInfo?.customer?.lastName || "");
  const [email, setEmail] = useState(customerInfo?.customer?.email || "");
  const [number, setNumber] = useState(customerInfo?.customer?.phone || "");
  const [schedule, setSchedule] = useState("");
  const [address, setAddress] = useState(customerInfo?.customer?.address || "");
  const [useCurrentLocation, setUseCurrentLocation] = useState(false);
  const [isLoadingLocation, setIsLoadingLocation] = useState(false);
  const [timeError, setTimeError] = useState(""); // Add error state for time validation
  const [addressInputMethod, setAddressInputMethod] = useState("manual"); // Add new state for address input method
  const [locationName, setLocationName] = useState("");
  const [openForm, setOpenForm] = useState(false);
  const [openSign, setOpenSign] = useState(false);
  const [isPickUp, setIsPickUp] = useState(false);
  const [isDeliver, setIsDeliver] = useState(false);
  const [isScheduleDelivery, setIsScheduleDelivery] = useState(false);
  const [selectedDeliveryTiming, setSelectedDeliveryTiming] = useState('Now'); // Track selected tab for Now/Later
  const [selectedOrderType, setSelectedOrderType] = useState(''); // Track which order type button was clicked

  let userData = localStorage.getItem("userInfo") ? JSON.parse(localStorage.getItem("userInfo")) : null;
  let loggedUser = sessionStorage.getItem("customerInfo") ? JSON.parse(sessionStorage.getItem("customerInfo")) : null;

  // let {setting} = state.userSetting;
  //   console.log(setting);

  useEffect(() => {
    if (loggedUser && loggedUser.customer) {
      setCustomerId(dispatch, loggedUser.customer.id);
      // selectHandler("Pick Up");
    } else {
      console.log('opning login');
      setOpenSign(true);
    }
  }, [])


  //  if(setting){
  //   setTimeout(() => {
  //    let textcolor = document.getElementById("title1");
  //    textcolor.style.color = setting.color_primary;
  //  }, 10);
  // }




  // let sokURL = window.location.href.indexOf('localhost') > 0 ?'https://online.menulive.in':window.location.origin;
  // const baseURL =config.baseURL;
  //  const payURL = "https://pay.digitallive24.com";

  //  const getCurrency = userInfo? userInfo.currency:"";
  //  const getPercent = setting? setting.taxPercent:"";


  //  const [qrDetails, setQrDetails] = useState([])

  let getTime = new Date();
  let closeByTime = Math.floor(getTime.getTime() / 1000) + 180;
  console.log(closeByTime);

  //   // const [item,setItem] =useState([]);
  // console.log(state.order);
  //   let items = [];
  //   if (order) {
  //     order.orderItems.map((o) => {
  //       items.push({
  //         price_data: {
  //           currency: getCurrency,
  //           product_data: {
  //             name: o.name
  //           },
  //           unit_amount: o.price * 100 + (o.price * getPercent / 100) * 100
  //         },
  //         quantity: o.quantity
  //       })
  //     });
  //   }

  //   console.log(items);


  const selectHandler = (orderType) => {
    // Determine actual order type based on timing selection
    let effectiveOrderType = orderType;

    setOrderType(dispatch, effectiveOrderType);
    setSelectedOrderType(orderType); // Keep original for card highlighting mapping

    // Always open dialog
    if (effectiveOrderType === "Pick Up") {
      setOpenForm(true);
      setIsPickUp(true);
      setIsDeliver(false);
      setIsScheduleDelivery(false);
    }
    else {
      setOpenForm(true);
      setIsDeliver(true);
      setIsScheduleDelivery(false);
      setIsPickUp(false);
    }

  };

  const handleCancle = () => {
    setOpenForm(false);
    setIsPickUp(false);
    setIsDeliver(false);
    setIsScheduleDelivery(false);
    setAddress("");
    setNumber("");
    setUserName("");
    setUserLName("");
    setSchedule("");
    setUseCurrentLocation(false);
    return props.history.push('/?' + window.location.href.split('?')[1])
  }
  const updateUserAddr = (lat, long) => {
    axios.put(`${config.authapi}/customer/${customerInfo.customer.id}`, {
      lat: lat,
      long: long,
      merchantCode: merchantCode,
    }, {
      headers: {
        'Authorization': 'Bearer ' + JSON.parse(sessionStorage.getItem("customerInfo")).token
      }
    }).then(res => {
      console.log(res);
      customerInfo.customer.lat = lat;
      customerInfo.customer.long = long;
      sessionStorage.setItem("customerInfo", JSON.stringify(customerInfo));
    })
  }
  const getCurrentLocation = () => {
    console.log("######## GETTING CURRENT LOCATION ####################");
    if (navigator.geolocation) {
      setIsLoadingLocation(true);
      navigator.geolocation.getCurrentPosition(
        (position) => {
          console.log(position);
          const { latitude, longitude } = position.coords;
          // Ideally, use reverse geocoding for a human-readable address
          console.log(`Current Location (${latitude}, ${longitude})`);
          //setAddress(`Current Location (${latitude}, ${longitude})`);
          setIsLoadingLocation(false);
          updateUserAddr(latitude, longitude);
        },
        (error) => {
          console.error("Error getting location:", error);
          console.log("Unable to get your current location. Please enter address manually.");
          setIsLoadingLocation(false);
          setAddressInputMethod("manual"); // Switch to manual if location fails
        },
        { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
      );
    } else {
      console.log("Geolocation is not supported by this browser.");
      setAddressInputMethod("manual"); // Switch to manual if geolocation not supported
    }
  };

  const handleAddressMethodChange = (method) => {
    setAddressInputMethod(method);
    if (method === "current") {
      getCurrentLocation();
    }
  };

  const handleCurrentLocationChange = (e) => {
    const checked = e.target.checked;
    setUseCurrentLocation(checked);
    if (checked) {
      getCurrentLocation();
    }
  };

  // Add time validation function
  const validateTime = (dateTimeString) => {
    if (!dateTimeString) return "Please select a time";

    const selectedDate = new Date(dateTimeString);
    const selectedHour = selectedDate.getHours();
    const selectedMinute = selectedDate.getMinutes();

    if (selectedDate < new Date()) {
      return "Please select future dates";
    }
    if (selectedHour < userData.openTime || selectedHour > userData.closeTime) {
      return "Please select time while it is open!";
    }

    return ""; // No error
  };

  // Update the schedule change handler to validate in real time
  const handleScheduleChange = (e) => {
    const newSchedule = e.target.value;
    setSchedule(newSchedule);
    setTimeError(validateTime(newSchedule));
  };

  // Check if all mandatory fields are filled for delivery
  const isDeliveryFormValid = () => {
    if (isDeliver || isScheduleDelivery) {


      // For manual address entry
      if (addressInputMethod === "manual" && !address.trim()) return false;


      // scheduled delivery needs valid time only when Later tab is selected
      if (isScheduleDelivery && selectedDeliveryTiming === 'Later' && (timeError || !schedule)) return false;
    }

    // pickup requires valid schedule only when Later tab is selected
    if (isPickUp && selectedDeliveryTiming === 'Later' && (timeError || !schedule)) return false;

    return true;
  };

  // Handler for dialog Next button - saves form data and closes dialog
  const handleDialogSave = () => {
    // Save customer info to session storage
    if (customerInfo) {
      customerInfo.customer.firstName = userName;
      customerInfo.customer.lastName = userLName;
      customerInfo.customer.phone = number;
      customerInfo.customer.email = email;
      customerInfo.customer.address = address;
      sessionStorage.setItem('customerInfo', JSON.stringify(customerInfo));
      updateCustomer(dispatch, customerInfo.customer.id, customerInfo.customer);
    }

    // Close the dialog
    setOpenForm(false);
  };

  // Handler for main page Next button - saves schedule and navigates to order page
  const handleFinalSubmit = () => {
    // For Schedule Delivery, validate and save the schedule time
    if (selectedDeliveryTiming === 'Later' && schedule) {
      const error = validateTime(schedule);
      if (error) {
        setTimeError(error);
        return;
      }

      const selectedDate = new Date(schedule);
      const timestamp = selectedDate.getTime();

      dispatch({
        type: ORDER_SET_SCHEDULE_DATE,
        payload: timestamp,
      });
    }

    // Navigate to order page
    props.history.push('/order?' + window.location.href.split('?')[1]);
  };





  return (
    <Box style={{ textAlign: "center", height: "100vh", backgroundColor: userData.themeColor }}>
      {openSign && !loggedUser && <Dialog open={true} fullWidth maxWidth="sm">
        <SignUp log={true} setOpenSign={setOpenSign}
          procedToCheckoutHandler={() => window.location.reload()} />
      </Dialog>}
      <Dialog
        aria-labelledby="max-width-dialog-title"
        open={openForm}
        fullWidth={true}
        maxWidth={state.widthScreen ? 'sm' : 'xs'}
        style={{ backgroundColor: '#fff!important' }}
        PaperProps={{
          style: {
            borderRadius: '12px',
            boxShadow: '0 8px 24px rgba(0,0,0,0.15)',
            overflow: 'hidden'
          }
        }}
      >
        <DialogTitle style={{
          padding: '20px 24px'

        }}>
          <div style={{
            fontSize: "1.7em",
            fontWeight: "600",
            borderBottom: "none",
            color: '#fff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}>
            {"Let us know bit more about you and order"}
          </div>
        </DialogTitle>

        <div style={{ height: "auto", padding: "24px", marginBottom: "20px" }}>

          {/* Pickup Time Warning - Only show when Later tab is selected */}
          {isPickUp && selectedDeliveryTiming === 'Later' &&
            <div className="note">
              <span style={{ marginRight: "8px", fontSize: "18px" }}>⏰</span>
              <span><strong>Note:</strong> Pickup time is between {userData?.openTime} to {userData?.closeTime} O'clock.</span>
            </div>
          }

          {/* Schedule Delivery Warning - Only show when Later tab is selected */}
          {isScheduleDelivery && selectedDeliveryTiming === 'Later' &&
            <div style={{
              marginBottom: "20px",
              backgroundColor: "#fff8e6",
              border: "1px solid #ffdb99",
              borderRadius: "8px",
              padding: "12px 16px",
              color: "#e67700",
              fontSize: "0.95em",
              display: "flex",
              alignItems: "center"
            }}>
              <span style={{ marginRight: "8px", fontSize: "18px" }}>⏰</span>
              <span><strong>Note:</strong> Schedule your delivery time between {userData?.openTime} to {userData?.closeTime}.</span>
            </div>
          }

          {/* Hidden fields remain the same */}
          {isPickUp && <span>
            <label style={{
              fontWeight: "600",
              display: "block",
              margin: "8px",
              fontSize: "1em",
              color: "#333"
            }} >Name <span style={{ color: "red" }}>*</span>  </label>
            <input className='userInput' style={{ color: userData.themeColor }} placeholder='Name' defaultValue={userName} type='text' onChange={(e) => setUserName(e.target.value)} />
          </span>}
          {isPickUp && <span>
            <label style={{
              fontWeight: "600",
              display: "block",
              margin: "8px",
              fontSize: "1em",
              color: "#333"
            }} >Last Name </label>
            <input className='userInput' style={{ color: userData.themeColor }} placeholder='Last Name' defaultValue={userLName} type='text' onChange={(e) => setUserLName(e.target.value)} />
          </span>}
          {isPickUp && <span>
            <label style={{
              fontWeight: "600",
              display: "block",
              margin: "8px",
              fontSize: "1em",
              color: "#333"
            }} >Phone No. <span style={{ color: "red" }}>*</span> </label>
            <input type='text' style={{ color: userData.themeColor }} className='userInput' defaultValue={number} placeholder='Mobile No' onChange={(e) => setNumber(e.target.value)} />
          </span>}



          {/* Delivery Address Section with improved styling and row layout */}
          {(isDeliver || isScheduleDelivery) &&
            <div style={{ marginBottom: "20px" }}>


              {/* Mobile Number field - MANDATORY */}
              <div style={{ marginBottom: "20px" }}>
                <label style={{
                  fontWeight: "600",
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "1em",
                  color: "#333"
                }}>
                  Mobile Number <span style={{ color: "red" }}>*</span>
                </label>
                <input
                  type="tel"
                  className='userInput'
                  placeholder='Enter mobile number'
                  onChange={(e) => setNumber(e.target.value)}
                  value={number}
                  style={{
                    width: "100%",
                    padding: "14px",
                    border: !number.trim() ? "1px solid #ddd" : "1px solid #ddd",
                    borderRadius: "8px",
                    fontSize: "16px",
                    transition: "border 0.2s ease"
                  }}
                />
              </div>

              {/* Name field (changed from Location Name) - OPTIONAL */}
              <div style={{ marginBottom: "20px" }}>
                <label style={{
                  fontWeight: "600",
                  display: "block",
                  marginBottom: "8px",
                  fontSize: "1em",
                  color: "#333"
                }}>
                  Name <span style={{ color: "#666", fontSize: "0.9em", fontWeight: "normal" }}>(optional)</span>
                </label>
                <input
                  type="text"
                  className='userInput'
                  placeholder='Your name'
                  onChange={(e) => setUserName(e.target.value)}
                  defaultValue={userName}
                  style={{
                    width: "100%",
                    padding: "14px",
                    border: "1px solid #ddd",
                    borderRadius: "8px",
                    fontSize: "16px",
                    transition: "border 0.2s ease"
                  }}
                />
              </div>

              {/* Manual address input */}
              {(
                <div style={{
                  animation: "fadeIn 0.3s ease",
                }}>
                  <label style={{
                    fontWeight: "600",
                    display: "block",
                    marginBottom: "8px",
                    fontSize: "1em",
                    color: "#333"
                  }}>
                    Address <span style={{ color: "red" }}>*</span>
                  </label>
                  <textarea
                    className='userInput'
                    placeholder='Enter delivery address'
                    onChange={(e) => setAddress(e.target.value)}
                    value={address}
                    defaultValue={address}
                    rows={5}
                    style={{
                      width: "100%",
                      minHeight: "100px",
                      padding: "14px",
                      border: "1px solid #ddd",
                      borderRadius: "8px",
                      resize: "vertical",
                      fontSize: "15px",
                      transition: "border 0.2s ease",
                      ":focus": {
                        outline: "none",
                        border: "1px solid #4a90e2"
                      }
                    }}
                  />
                  <span><a target="_blank" style={{ marginBottom: "10px", padding: "10px" }} href={`https://maps.google.com/?q=${customerInfo.customer.lat},${customerInfo.customer.long}`}> My Location</a></span>
                  <button className='c_btn' style={{ background: "#000", color: "#fff", fontSize: "1.2em", minWidth: "245px" }} onClick={() => getCurrentLocation()}>Set My Current Location</button>
                </div>
              )}
            </div>
          }

          {/* Schedule Time field - Shows only when 'Later' tab is selected */}
          {selectedDeliveryTiming === 'Later' && (isPickUp || isScheduleDelivery) &&
            <div style={{ marginBottom: "20px" }}>
              <label style={{
                fontWeight: "600",
                display: "block",
                marginBottom: "8px",
                fontSize: "1em",
                color: "#333"
              }}>
                Schedule <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type='datetime-local'
                className='userInput'
                style={{
                  width: "100%",
                  padding: "14px",
                  border: timeError ? "2px solid #ff0000" : "1px solid #ddd",
                  borderRadius: "8px",
                  fontSize: "16px",
                  transition: "all 0.2s ease"
                }}
                onChange={handleScheduleChange}
                value={schedule}
              />
              {timeError && (
                <div style={{
                  color: "#ff0000",
                  fontSize: "0.85em",
                  marginTop: "6px",
                  textAlign: "left",
                  display: "flex",
                  alignItems: "center"
                }}>
                  <span style={{ marginRight: "5px" }}>⚠️</span> {timeError}
                </div>
              )}
            </div>
          }

          {/* Action Buttons with improved styling */}
          <div style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            paddingTop: "20px",
            marginTop: "15px",
            borderTop: "1px solid #eaeaea"
          }}>
            <button
              className='c_btn'
              onClick={() => handleCancle()}
              style={{
                padding: "12px 24px",
                minWidth: "120px",
                border: "1px solid #ddd",
                borderRadius: "8px",
                backgroundColor: "#f5f5f5",
                fontSize: "15px",
                fontWeight: "500",
                cursor: "pointer",
                transition: "all 0.2s ease"
              }}
            >
              Back
            </button>
            <button
              className='s_btn'
              onClick={handleDialogSave}
              disabled={
                (isPickUp && !userName) ||
                (isScheduleDelivery && (!number || !address)) ||
                (isDeliver && (!number || !address))
              }
              style={{
                padding: "12px 24px",
                minWidth: "120px",
                fontWeight: "600",
                backgroundColor: userData.themeColor,
                color: userData.themeTxtColor,
                border: "none",
                borderRadius: "8px",
                fontSize: "15px",
                opacity: (
                  (isPickUp && !userName) ||
                  (isScheduleDelivery && (!number || !address)) ||
                  (isDeliver && (!number || !address))
                ) ? "0.6" : "1",
                cursor: (
                  (isPickUp && !userName) ||
                  (isScheduleDelivery && (!number || !address)) ||
                  (isDeliver && (!number || !address))
                ) ? "not-allowed" : "pointer",
                transition: "all 0.2s ease",
                boxShadow: "0 2px 8px rgba(0,0,0,0.1)"
              }}
            >
              Save
            </button>
          </div>
        </div>
      </Dialog>

      <Box style={{ height: '100%!important', backgroundColor: userData.themeColor, padding: "20px" }}>
        <h2 style={{ color: userData.themeTxtColor }}> How would you like to collect order?</h2>
        <div style={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '20px',
          maxHeight: 'calc(100vh - 119px)',
          overflow: 'hidden',
          overflowY: 'auto'
        }}>
          {/* First Row: Pick Up and Delivery */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '20px',
            width: '100%',
            maxWidth: '600px'
          }}>
            <Card className={styles.card} style={{
              flex: '1',
              maxWidth: '250px',
              border: selectedOrderType === 'Pick Up' ? `4px solid #ff9800` : 'none',
              backgroundColor: selectedOrderType === 'Pick Up' ? '#fff3e0' : userData.themeTxtColor,
              boxShadow: selectedOrderType === 'Pick Up' ? '0 8px 24px rgba(255, 152, 0, 0.4)' : undefined,
              transform: selectedOrderType === 'Pick Up' ? 'scale(1.05)' : 'scale(1)',
              transition: 'all 0.3s ease'
            }}>
              <CardActionArea onClick={() => selectHandler('Pick Up')} style={{ height: '100%', backgroundColor: 'transparent', color: userData.themeColor }}>
                <CardMedia
                  component="img"
                  image="/images/pickup.png"
                  className={styles.media}
                  style={{ height: "166px", width: "140px", margin: "0 auto" }}
                />
                <CardContent style={{ padding: '5px', height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Typography
                    gutterBottom
                    variant="h4"
                    color="textPrimary"
                    component="p"
                    style={{ margin: 0, fontSize: "1.4em", fontWeight: selectedOrderType === 'Pick Up' ? '700' : '500' }}
                  >
                    PICK UP
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>

            <Card className={styles.card} style={{
              flex: '1',
              maxWidth: '250px',
              border: (selectedOrderType === 'Delivery' || selectedOrderType === 'Schedule Delivery') ? `4px solid #ff9800` : 'none',
              backgroundColor: (selectedOrderType === 'Delivery' || selectedOrderType === 'Schedule Delivery') ? '#fff3e0' : userData.themeTxtColor,
              boxShadow: (selectedOrderType === 'Delivery' || selectedOrderType === 'Schedule Delivery') ? '0 8px 24px rgba(255, 152, 0, 0.4)' : undefined,
              transform: (selectedOrderType === 'Delivery' || selectedOrderType === 'Schedule Delivery') ? 'scale(1.05)' : 'scale(1)',
              transition: 'all 0.3s ease'
            }}>
              <CardActionArea onClick={() => selectHandler('Delivery')} id='counter' style={{ height: '100%', backgroundColor: 'transparent', color: userData.themeColor }}>
                <CardMedia
                  component="img"
                  alt="At counter"
                  image="/images/delivery.png"
                  className={styles.media}
                  style={{ height: "166px", width: "140px", margin: "0 auto" }}
                />
                <CardContent style={{ padding: '5px', height: '50px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                  <Typography
                    gutterBottom
                    variant="h4"
                    color="textPrimary"
                    component="p"
                    style={{ margin: 0, fontSize: "1.4em", fontWeight: (selectedOrderType === 'Delivery' || selectedOrderType === 'Schedule Delivery') ? '700' : '500' }}
                  >
                    DELIVERY
                  </Typography>
                </CardContent>
              </CardActionArea>
            </Card>
          </div>

          {/* Second Row: Now and Later - Tab Style */}
          <div style={{
            display: 'flex',
            justifyContent: 'center',
            gap: '0',
            width: '100%',
            maxWidth: '600px',
            backgroundColor: '#e0e0e0',
            borderRadius: '12px',
            padding: '4px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)'
          }}>
            <button
              onClick={() => {
                setSelectedDeliveryTiming('Now');
              }}
              style={{
                flex: '1',
                padding: '16px 24px',
                border: 'none',
                borderRadius: '8px',
                fontSize: '1.4em',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                backgroundColor: selectedDeliveryTiming === 'Now' ? userData.themeTxtColor : 'transparent',
                color: selectedDeliveryTiming === 'Now' ? userData.themeColor : '#666',
                boxShadow: selectedDeliveryTiming === 'Now' ? '0 2px 4px rgba(0,0,0,0.15)' : 'none',
                transform: selectedDeliveryTiming === 'Now' ? 'scale(1.02)' : 'scale(1)'
              }}
            >
              NOW
            </button>

            <button
              onClick={() => {
                setSelectedDeliveryTiming('Later');
              }}
              style={{
                flex: '1',
                padding: '16px 24px',
                border: 'none',
                borderRadius: '8px',
                fontSize: '1.4em',
                fontWeight: '600',
                cursor: 'pointer',
                transition: 'all 0.3s ease',
                backgroundColor: selectedDeliveryTiming === 'Later' ? userData.themeTxtColor : 'transparent',
                color: selectedDeliveryTiming === 'Later' ? userData.themeColor : '#666',
                boxShadow: selectedDeliveryTiming === 'Later' ? '0 2px 4px rgba(0,0,0,0.15)' : 'none',
                transform: selectedDeliveryTiming === 'Later' ? 'scale(1.02)' : 'scale(1)'
              }}
            >
              LATER
            </button>
          </div>

          {/* Schedule Input - Shows on main page when Later is selected */}
          {selectedDeliveryTiming === 'Later' && (
            <div style={{
              marginTop: '20px',
              width: '100%',
              maxWidth: '600px',
              backgroundColor: userData.themeTxtColor,
              borderRadius: '12px',
              padding: '20px',
              boxShadow: '0 4px 12px rgba(0,0,0,0.15)'
            }}>
              <div style={{
                marginBottom: '15px',
                backgroundColor: '#fff8e6',
                border: '1px solid #ffdb99',
                borderRadius: '8px',
                padding: '12px 16px',
                color: '#e67700',
                fontSize: '0.95em',
                display: 'flex',
                alignItems: 'center'
              }}>
                <span style={{ marginRight: '8px', fontSize: '18px' }}>⏰</span>
                <span><strong>Note:</strong> Schedule time is between {userData?.openTime} to {userData?.closeTime} O'clock.</span>
              </div>

              <label style={{
                fontWeight: '600',
                display: 'block',
                marginBottom: '8px',
                fontSize: '1em',
                color: userData.themeColor
              }}>
                Select Schedule Time <span style={{ color: 'red' }}>*</span>
              </label>
              <input
                type='datetime-local'
                className='userInput'
                style={{
                  width: '100%',
                  padding: '14px',
                  border: timeError ? '2px solid #ff0000' : '1px solid #ddd',
                  borderRadius: '8px',
                  fontSize: '16px',
                  transition: 'all 0.2s ease'
                }}
                onChange={handleScheduleChange}
                value={schedule}
              />
              {timeError && (
                <div style={{
                  color: '#ff0000',
                  fontSize: '0.85em',
                  marginTop: '6px',
                  textAlign: 'left',
                  display: 'flex',
                  alignItems: 'center'
                }}>
                  <span style={{ marginRight: '5px' }}>⚠️</span> {timeError}
                </div>
              )}
            </div>
          )}

        </div>
      </Box>

      {/* Bottom Navigation Buttons */}
      <div style={{
        position: 'fixed',
        bottom: '20px',
        left: '20px',
        right: '20px',
        display: 'flex',
        justifyContent: 'center',
        gap: '16px',
        zIndex: 1000,
        borderRadius: '20px',
        border: '1px solid rgba(0,0,0,0.05)'
      }}>
        <button
          onClick={() => props.history.push('/order?' + window.location.href.split('?')[1])}
          style={{
            padding: '14px 24px',
            flex: '1',
            maxWidth: '180px',
            fontSize: '1.1em',
            fontWeight: '600',
            backgroundColor: '#f5f5f5',
            color: '#666',
            border: 'none',
            borderRadius: '12px',
            cursor: 'pointer',
            transition: 'all 0.3s ease',
            whiteSpace: 'nowrap'
          }}
        >
          Skip
        </button>

        <button
          onClick={handleFinalSubmit}
          disabled={
            !(selectedOrderType && customerInfo && (
              (selectedOrderType === 'Pick Up' && customerInfo.customer.firstName) ||
              ((selectedOrderType === 'Delivery') && customerInfo.customer.phone && customerInfo.customer.address)
            ))
          }
          style={{
            padding: '14px 24px',
            flex: '1.5',
            maxWidth: '240px',
            fontSize: '1.1em',
            fontWeight: '600',
            backgroundColor: (selectedOrderType && customerInfo && (
              (selectedOrderType === 'Pick Up' && customerInfo.customer.firstName) ||
              ((selectedOrderType === 'Delivery') && customerInfo.customer.phone && customerInfo.customer.address)
            )) ? userData.themeTxtColor : '#e0e0e0',
            color: (selectedOrderType && customerInfo && (
              (selectedOrderType === 'Pick Up' && customerInfo.customer.firstName) ||
              ((selectedOrderType === 'Delivery') && customerInfo.customer.phone && customerInfo.customer.address)
            )) ? userData.themeColor : '#999',
            border: 'none',
            borderRadius: '12px',
            cursor: (selectedOrderType && customerInfo && (
              (selectedOrderType === 'Pick Up' && customerInfo.customer.firstName) ||
              ((selectedOrderType === 'Delivery') && customerInfo.customer.phone && customerInfo.customer.address)
            )) ? 'pointer' : 'not-allowed',
            transition: 'all 0.3s ease',
            boxShadow: (selectedOrderType && customerInfo && (
              (selectedOrderType === 'Pick Up' && customerInfo.customer.firstName) ||
              ((selectedOrderType === 'Delivery') && customerInfo.customer.phone && customerInfo.customer.address)
            )) ? '0 4px 12px rgba(0,0,0,0.2)' : 'none',
            whiteSpace: 'nowrap'
          }}
          onMouseEnter={(e) => {
            if (!e.target.disabled) {
              e.target.style.transform = 'translateY(-2px)';
              e.target.style.boxShadow = '0 6px 16px rgba(0,0,0,0.3)';
            }
          }}
          onMouseLeave={(e) => {
            if (!e.target.disabled) {
              e.target.style.transform = 'translateY(0)';
              e.target.style.boxShadow = '0 4px 12px rgba(0,0,0,0.2)';
            }
          }}
        >
          Next
        </button>
      </div>
    </Box>
  );
}
